import { render, staticRenderFns } from "./LeadyList.vue?vue&type=template&id=6c13ea04&"
import script from "./LeadyList.vue?vue&type=script&lang=ts&"
export * from "./LeadyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports